// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'

// This is the base class from which the other inputs extend.
// This class simply provides consistent custom event handling

class UpdatedInputBase extends React.Component {
  static propTypes = {
    id: string.isRequired,
    input: object.isRequired,
    meta: object.isRequired,
    onBlurCustom: func,
    onChangeCustom: func,
    onFocusCustom: func,
  }

  static defaultProps = {
    className: '',
  }

  // Allows for custom event handlers to be passed down as:
  // onBlurCustom, onChangeCustom and onFocusCustom.
  // This is because the redux-form <Field /> does not
  // pass down properties with the event's actual name space
  // eg. "onBlur"
  handleEvent = (e, eventType) => {
    const { input } = this.props
    const customEventHandler = this.props[`${eventType}Custom`]

    const inputEventHandler = input[eventType]

    if (customEventHandler) {
      // the custom event handler will receive the event as well as the
      // default event handler from this.props.input
      return customEventHandler(e, inputEventHandler)
    } else if (inputEventHandler) {
      return inputEventHandler(e)
    } else {
      // this should never be possible in production!
      console.warn(`Warning! UpdatedInputBase.handleEvent eventType: ${eventType} was assigned but has no event handler!`)
      return false
    }
  }

  // this.props.onBlurCustom
  handleBlur = e => this.handleEvent(e, 'onBlur')

  // this.props.onChangeCustom
  handleChange = e => this.handleEvent(e, 'onChange')

  // this.props.onFocusCustom
  handleFocus = e => this.handleEvent(e, 'onFocus')

  render () {
    return null
  }
}

export default UpdatedInputBase
